/**
 * Determines whether the popover should close based on focusout relatedTarget.
 * Returns true if focus moved outside both host and popover elements.
 */
export function shouldCloseOnFocusOut(
    host: HTMLElement,
    popover: HTMLElement | null,
    relatedTarget: EventTarget | null
): boolean {
    if (relatedTarget === null) return true;
    if (!isNode(relatedTarget)) return true;
    if (host.contains(relatedTarget)) return false;
    if (popover?.contains(relatedTarget)) return false;
    return true;
}

/** Type guard: checks if an EventTarget is a DOM Node via duck typing. */
function isNode(target: EventTarget): target is Node {
    return 'nodeType' in target;
}
